import React, { useState, ChangeEvent, useEffect } from "react";
import {
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  CreateNewCategory,
  Add,
  Cancel,
  CategoryName,
} from "../../../Utils/Constants";
import { Btn } from "../../../AbstractElements";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import {
  addDiscount,
  setLoading,
} from "../../../ReduxToolkit/Reducers/AppReducer";
import { getVendorID } from "../../../services/helper";

export default function AddDiscount() {
  const [tableform, setTableform] = useState({
    coupon: "",
    amount: "",
    discount_type: "percent",
    description: "",
    usage_limit: null,
    expiry_date: "",
  });

  const dispatch = useDispatch();
  const vendor_id = getVendorID();
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setTableform((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    toggle();

    try {
      const formatedData = { ...tableform, vendor_id };
      dispatch(setLoading(true));
      const result = await dispatch(addDiscount(formatedData)).unwrap();
      if (result.data.success) {
        toast.success("Discount Saved Successfully");
      }
      setTableform({
        coupon: "",
        amount: "",
        discount_type: "percent",
        description: "",
        usage_limit: null,
        expiry_date: "",
      });
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      console.log(error);
      toast.error("Error saving Discount");
    }
  };
  return (
    <div>
      <div>
        <Btn className="btn btn-primary" color="primary" onClick={toggle}>
          <i className="fa fa-plus me-2"></i> {"Add New Discount"}
        </Btn>
      </div>
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>New Discount</ModalHeader>
        <ModalBody className="custom-input">
          <div className="create-category">
            <Row>
              <Col sm={6} className="m-0">
                <FormGroup>
                  <Label>Coupon Code</Label>
                  <Input
                    type="text"
                    name="coupon"
                    value={tableform?.coupon}
                    onChange={(e) => handleChange(e)}
                  />
                </FormGroup>
              </Col>
              <Col sm={6} className="m-0">
                <FormGroup>
                  <Label>Discount Ammount</Label>
                  <Input
                    type="number"
                    name="amount"
                    value={tableform?.amount}
                    onChange={(e) => handleChange(e)}
                  />
                </FormGroup>
              </Col>
              <Col sm={6} className="m-0">
                <FormGroup>
                  <Label>Discount Type</Label>
                  <Input
                    type="select"
                    name="discount_type"
                    onChange={(e) => handleChange(e)}
                    value={tableform?.discount_type}
                  >
                    <option value={"percent"}>Percent</option>
                    <option value={"fixed_cart"}>Fix Price</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col sm={6} className="m-0">
                <FormGroup>
                  <Label>Description</Label>
                  <Input
                    type="text"
                    name="description"
                    value={tableform?.description}
                    onChange={(e) => handleChange(e)}
                  />
                </FormGroup>
              </Col>
              <Col sm={6} className="m-0 d-flex align-items-center">
                <FormGroup switch className="mb-0">
                  <Input
                    type="switch"
                    role="switch"
                    id="usage_switch"
                    checked={tableform?.usage_limit === 1}
                    onChange={(e) =>
                      setTableform((prev) => ({
                        ...prev,
                        usage_limit: e.target.checked ? 1 : null,
                      }))
                    }
                  />
                  <Label for="usage_switch" check>
                    {tableform?.usage_limit === 1 ? "Single Use" : "Unlimited"}
                  </Label>
                </FormGroup>
              </Col>

              <Col sm={6} className="m-0">
                <FormGroup>
                  <Label>Expiry Date</Label>
                  <Input
                    type="date"
                    name="expiry_date"
                    value={tableform?.expiry_date}
                    onChange={(e) => handleChange(e)}
                  />
                </FormGroup>
              </Col>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter>
          <Btn
            color="light"
            onClick={() => {
              toggle();
            }}
          >
            {Cancel}
          </Btn>
          <Btn color="primary" onClick={handleSave}>
            {Add}
          </Btn>
        </ModalFooter>
      </Modal>
    </div>
  );
}
